import { useEffect } from 'react';
import { initPostHog } from '@/lib/analytics/client';
import { usePostHogAuth } from '@/hooks/usePostHog';

// Provider component
interface PostHogProviderProps {
  children: React.ReactNode;
}

function PostHogAuthWrapper({ children }: PostHogProviderProps) {
  usePostHogAuth();
  return <>{children}</>;
}

// The app drives analytics through the buffering singleton in client.ts (not
// posthog-js/react's context), so we skip PHProvider entirely — that keeps
// posthog-js out of the eager bundle; initPostHog loads it after mount.
export function PostHogProvider({ children }: PostHogProviderProps) {
  useEffect(() => {
    initPostHog();
  }, []);

  return <PostHogAuthWrapper>{children}</PostHogAuthWrapper>;
}
